module.exports = __webpack_public_path__ + "img/sl.25604634.svg";